export default __webpack_public_path__ + "static/media/step-alert.ec0438ab.svg";